import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { useState, useEffect, useContext } from 'react';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import isValid from 'date-fns/isValid';
import { KeyboardDatePicker, MuiPickersUtilsProvider, MuiPickersContext } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ruLocale from 'date-fns/locale/ru';
import { CircularProgress, Toolbar, Button, Typography, IconButton } from '@material-ui/core';
import classnames from 'classnames';
import { isYearAndMonthViews, isYearOnlyView } from '@material-ui/pickers/_helpers/date-utils';
import { Clear, Event } from '@material-ui/icons';
var stringFormat = 'dd.MM.yyyy';

var formatValue = function formatValue(value) {
  var formattedValue = !value ? null : parse(value, stringFormat, new Date());

  if (!isValid(formattedValue)) {
    formattedValue = null;
  }

  return formattedValue;
};

var minDate = new Date('1800-01-01');
var maxDate = new Date('2100-01-01');
export var renderDatePickerToolbar = function renderDatePickerToolbar(_ref) {
  var classes = _ref.classes,
      beforeText = _ref.beforeText,
      afterText = _ref.afterText;
  return function (props) {
    var _classnames8;

    var date = props.date,
        views = props.views,
        setOpenView = props.setOpenView,
        isLandscape = props.isLandscape,
        openView = props.openView;
    var utils = useContext(MuiPickersContext);
    var isYearOnly = React.useMemo(function () {
      return isYearOnlyView(views);
    }, [views]);
    var isYearAndMonth = React.useMemo(function () {
      return isYearAndMonthViews(views);
    }, [views]);

    var renderDefaultHeader = function renderDefaultHeader() {
      return React.createElement(React.Fragment, null, React.createElement(Button, {
        variant: 'text',
        onClick: function onClick() {
          return setOpenView('year');
        },
        className: classnames(classes.datePickerToolbarTxt, _defineProperty({}, classes.datePickerToolbarBtnSelected, openView === 'year'))
      }, React.createElement(Typography, {
        variant: isYearOnly ? 'h3' : 'subtitle1'
      }, utils.getYearText(date))), !isYearOnly && !isYearAndMonth && React.createElement(Button, {
        variant: 'text',
        onClick: function onClick() {
          return setOpenView('date');
        },
        className: classnames(_defineProperty({}, classes.datePickerToolbarDateLandscape, isLandscape))
      }, React.createElement(Typography, {
        variant: 'h4',
        align: isLandscape ? 'left' : 'center',
        className: classnames(classes.datePickerToolbarTxt, _defineProperty({}, classes.datePickerToolbarBtnSelected, openView === 'date'))
      }, utils.getDatePickerHeaderText(date))), isYearAndMonth && React.createElement(Button, {
        variant: 'text',
        onClick: function onClick() {
          return setOpenView('month');
        }
      }, React.createElement(Typography, {
        variant: 'h4',
        className: classnames(classes.datePickerToolbarTxt, _defineProperty({}, classes.datePickerToolbarBtnSelected, openView === 'month'))
      }, utils.getMonthText(date))));
    };

    var renderSelectDateHeader = function renderSelectDateHeader() {
      return React.createElement("div", {
        className: classes.datePickerToolbarButtonsDate
      }, beforeText && React.createElement(Typography, {
        variant: 'button',
        className: classes.datePickerToolbarButtonsDateTxt
      }, beforeText, "\xA0\xA0"), React.createElement(Button, {
        variant: 'text',
        onClick: function onClick() {
          return setOpenView('date');
        },
        className: classes.datePickerToolbarButtonsDateBtn
      }, React.createElement(Typography, {
        variant: 'button',
        className: classnames(classes.datePickerToolbarButtonsDateTxt, _defineProperty({}, classes.datePickerToolbarButtonsDateTxtSelected, openView === 'date'))
      }, format(date, 'd'))), React.createElement(Button, {
        variant: 'text',
        onClick: function onClick() {
          return setOpenView('month');
        },
        className: classes.datePickerToolbarButtonsDateBtn
      }, React.createElement(Typography, {
        variant: 'button',
        className: classnames(classes.datePickerToolbarButtonsDateTxt, _defineProperty({}, classes.datePickerToolbarButtonsDateTxtSelected, openView === 'month'))
      }, format(date, 'MMMM', {
        locale: ruLocale
      }))), React.createElement(Button, {
        variant: 'text',
        onClick: function onClick() {
          return setOpenView('year');
        },
        className: classes.datePickerToolbarButtonsDateBtn
      }, React.createElement(Typography, {
        variant: 'button',
        className: classnames(classes.datePickerToolbarButtonsDateTxt, _defineProperty({}, classes.datePickerToolbarButtonsDateTxtSelected, openView === 'year'))
      }, format(date, 'yyyy'))), afterText && React.createElement(Typography, {
        variant: 'button',
        className: classes.datePickerToolbarButtonsDateTxt
      }, "\xA0\xA0", afterText));
    };

    return React.createElement(Toolbar, {
      className: classnames((_classnames8 = {}, _defineProperty(_classnames8, classes.datePickerToolbar, !isYearOnly), _defineProperty(_classnames8, classes.datePickerToolbarLandscape, isLandscape), _classnames8))
    }, renderSelectDateHeader());
  };
};

function DateComponent(props) {
  var _classnames9;

  var id = props.id,
      required = props.required,
      field = props.field,
      value = props.value,
      error = props.error,
      onFieldChange = props.onFieldChange,
      classes = props.classes,
      slim = props.slim,
      inputLabelRef = props.inputLabelRef,
      labelWidth = props.labelWidth,
      disabled = props.disabled;
  var formattedValue = formatValue(value);

  var _useState = useState(formattedValue),
      _useState2 = _slicedToArray(_useState, 2),
      componentValue = _useState2[0],
      setComponentValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      componentError = _useState4[0],
      setComponentError = _useState4[1];

  var ID = id || field.name;
  var min, max;

  if (field.params && field.params.date) {
    if (field.params.date.min) {
      min = field.params.date.min;
    }

    if (field.params.date.max) {
      max = field.params.date.max;
    }
  }

  useEffect(function () {
    setComponentValue(formatValue(value));
  }, [value]);
  /**
   * Изменение в поле ввода
   * @param date
   */

  var onChange = function onChange(date) {
    // Если дата валидная или строка ввода пустая, то удаляем ошибку
    if (isValid(date) || date === null) {
      setComponentError('');
    }

    setComponentValue(date);
  };
  /**
   * Потеря фокуса
   */


  var onBlur = function onBlur() {
    if (isValid(componentValue) && !componentError) {
      // Если дата валидная и нет ошибок, то сохраняем дату в текстовом формате
      onFieldChange(ID, format(componentValue, stringFormat));
    } else if (componentValue === null && formattedValue !== null) {
      // Если поле ввода пустое и есть дефолтная дата, то сохраняем пустую дату
      onFieldChange(ID, '');
    } else {
      // в остальных случаях возвращаем дефолтную дату и дефолтную ошибку
      setComponentValue(formattedValue);
      setComponentError('');
    }
  };
  /**
   * Клик по дате в календаре или очистка поля из календаря
   * @param date
   */


  var onAccept = function onAccept(date) {
    onFieldChange(ID, date === null ? '' : format(date, stringFormat));
  };
  /**
   * Очистка поля из календаря
   */


  var onClear = function onClear() {
    onFieldChange(ID, '');
  };
  /**
   * Устанавка сообщения об ошибке от компонента
   * @param errorMessage
   */


  var onError = function onError(errorMessage) {
    setComponentError(errorMessage);
  };

  return React.createElement(React.Fragment, null, React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils,
    locale: ruLocale
  }, React.createElement(KeyboardDatePicker, {
    fullWidth: true,
    label: field.label,
    id: ID,
    name: field.name,
    variant: 'inline',
    onChange: onChange,
    onAccept: onAccept,
    onError: onError,
    value: componentValue,
    format: stringFormat,
    mask: value ? '__.__.____' : '',
    invalidDateMessage: "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u044B",
    minDateMessage: "\u0414\u0430\u0442\u0430 \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 ".concat(min ? format(min, stringFormat) : '01.01.1800'),
    maxDateMessage: "\u0414\u0430\u0442\u0430 \u043D\u0435 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 ".concat(max ? format(max, stringFormat) : '01.01.2100'),
    minDate: min || minDate,
    maxDate: max || maxDate,
    error: !!componentError || !!error,
    helperText: componentError || error,
    required: !!required,
    disabled: disabled,
    inputVariant: 'outlined',
    ToolbarComponent: renderDatePickerToolbar({
      classes: classes
    }),
    InputProps: {
      labelWidth: labelWidth,
      onBlur: onBlur,
      classes: {
        disabled: classes.disabledInput,
        input: slim ? classes.slimOutlinedInput : classes.baseOutlinedInput,
        root: slim ? classes.slimOutlinedInputRoot : classes.baseOutlinedInputRoot,
        notchedOutline: classes.notchedOutline
      }
    },
    InputLabelProps: {
      ref: inputLabelRef,
      classes: {
        root: classnames(classes.label, labelWidth ? classnames(classes.clippedLabel, classes.clippedLabelWithAdornment) : '', slim ? classes.slimOutlinedLabel : classes.baseOutlinedLabel),
        shrink: classes.shrinkLabel
      }
    },
    autoOk: true,
    PopoverProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    },
    KeyboardButtonProps: {
      size: slim ? 'small' : 'medium'
    },
    keyboardIcon: React.createElement(Event, {
      fontSize: slim ? 'small' : 'default'
    })
  })), componentValue && !disabled && React.createElement(IconButton, {
    className: classnames(classes.clearButton, classes.dateClearButton, (_classnames9 = {}, _defineProperty(_classnames9, classes.clearButtonSlim, slim), _defineProperty(_classnames9, classes.dateClearButtonSlim, slim), _classnames9)),
    size: slim ? 'small' : 'medium',
    "aria-label": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435",
    onClick: onClear
  }, React.createElement(Clear, {
    fontSize: slim ? 'small' : 'default'
  })));
}

var DateField = function DateField(props) {
  var classes = props.classes,
      validation = props.validation,
      slim = props.slim;
  return React.createElement("div", {
    className: classes.fieldContainer
  }, React.createElement(DateComponent, Object.assign({}, props)), validation && React.createElement("div", {
    className: classes.fieldLoaderContainer
  }, React.createElement(CircularProgress, {
    className: classnames(classes.fieldLoader, _defineProperty({}, classes.slimFieldLoader, !!slim)),
    size: slim ? 16 : 24,
    thickness: 4
  })));
};

export default DateField;